export const SET_FILTER = 'app/GivingAccountPage/SET_FILTER';

export const key = 'givingAccountPage';

export const TransactionTypeLabels = {
  GivingAccountFunding: 'Funding',
  GivingAccountWithdrawal: 'Paid',
  GivingAccountTransferInbound: 'Inbound Transfer',
  GivingAccountTransferOutbound: 'Outbound Transfer',
};
